import {all, call, put} from 'redux-saga/effects';
import request from '../../../lib/request';
import {FORM_ERROR} from 'final-form';
import axios from 'axios';

export const WISHLIST_REQUEST = 'landing/wishlist/WISHLIST_REQUEST';
export const WISHLIST_FAILURE = 'landing/wishlist/WISHLIST_FAILURE';
export const WISHLIST_SUCCESS = 'landing/wishlist/WISHLIST_SUCCESS';

export const handleWishListRequest = payload => ({
  type: WISHLIST_REQUEST,
  isLoading: true,
  payload,
});

export const handleWishListSuccess = () => ({
  type: WISHLIST_SUCCESS,
  isLoading: false,
});

export const handleWishListFailure = () => ({
  type: WISHLIST_FAILURE,
  isLoading: false,
});

export function* onHandleWishListRequest({payload: {firstName, lastName, email, major}}) {
  console.log(
    '#onHandleWishListRequest, firstName: %s, lastName: %s, email: %s, major: %s',
    firstName,
    lastName,
    email,
    major
  );

  let payload = {
    firstName,
    lastName,
    email,
    major,
  };

  console.log('#onHandleWishListRequest, payload: ', payload);

  const waitlistObj = {
    firstName: 'Daniel',
    lastName: 'Fatade',
    email: 'reggie@syr.edu',
    major: 'Computer Engineering',
    // skills: ['NodeJS', 'Python'],
  };

  try {
    console.log('#onHandleWaitListRequest, try block');

    const response = yield call(request.post, '/waitlist/general', {waitlist: payload});
    // axios
    //   .post(`https://cllctve-backend-dot-alpha-247519.ue.r.appspot.com/api/waitlist/general`, {
    //     waitlist: payload,
    //   })
    //   .then(res => {
    //     console.log(res);
    //     console.log(res.data);
    //   })
    //   .then(alert('You have been added to the waitlist!'))

    // console.log('#onHandleWaitListRequest, response: ', response);
    console.log('response: ', response);
    alert('You have been added to the waitlist!');
    yield put(handleWishListSuccess());
  } catch (err) {
    console.error('Error, failed to handle wish list request, err: ', err);
    yield put(handleWishListFailure(err));
  }
}

// ****************** SETTING INITAL STATE OF REDUCER ******************

const INITIAL_STATE = {
  isLoading: false,
  error: null,
};

// ******************  LANDING PAGE REDUCER ******************

export default function landing(state = INITIAL_STATE, action) {
  switch (action.type) {
    case WISHLIST_REQUEST:
      return {...state, isLoading: true};
    case WISHLIST_SUCCESS:
      return {...state, isLoading: false};
    case WISHLIST_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload.errors,
      };
    default:
      return state;
  }
}
